import { DariCalendarService } from '../../../services/DariCalendar';
import { GL_Child } from '../../../models/GL_Child';
import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import {GL_MasterService} from '../../../services/Acc_GL_Master.service';
import { ActivatedRoute } from '@angular/router';
import { UtilityService } from '../../../services/Acc_Utility.service';
import { Global } from '../../global';
import * as XLSX from 'xlsx';

@Component({
  selector: 'app-gl-ledger',
  templateUrl: './gl-ledger.component.html',
  styleUrls: ['./gl-ledger.component.css']
})
export class GlLedgerComponent implements OnInit {
  ArrLabels: any;
  labels: any = {};
  mydate: Date = new Date();

  gL_Child: GL_Child = {
    GL_MasterCode: "",
    GL_ChildCode: "",
    GL_ChildDesc: "",
    GL_ChildDesc_en: "",
    CurrentBalance: 0,
    RecordStat:"O",
    AuthStat: "A",
    MakerID: "test",
    CheckerID: "test",
    CreateDate: new Date(),
    UDF1: '',
    UDF2: '',
    UDF3: ''
  };

  glLedgers: any;

  constructor(
    private DariCalendar: DariCalendarService,
    private GL_MasterService: GL_MasterService,
    private global:Global,
    private UtilityService: UtilityService,
    private route : ActivatedRoute
  ) 
  {
    route.params.subscribe(p => {this.gL_Child.GL_ChildCode = p['gL_Code'];})
   }

  ngOnInit() {
    this.getGlLedgers();
    this.getLabels();
    console.log(this.DariCalendar.PersianCalendar(this.mydate));
    
  }

  @ViewChild('tableReport') table: ElementRef;
  exportAsXLSX(): void {
    const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(this.table.nativeElement);
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
    XLSX.writeFile(wb, 'leadgerList.xlsx');
  }




  getGlLedgers()
  {
    this.GL_MasterService.getGLLedgers(this.gL_Child.GL_ChildCode)
      .subscribe(response => {
        if (response) {
            this.glLedgers = response;
            for (let i in this.glLedgers)
            {
              this.glLedgers[i].value_Date_Da = this.DariCalendar.PersianCalendar(new Date(this.glLedgers[i].value_Date));
            }
        }
    },
    error => console.log("error --> " + error))

  }

  getLabels(){
    this.UtilityService.getLabels('gl-ledger',this.global.lang)
      .subscribe(response => {
          if(response){
              this.ArrLabels = response;
              this.setLabels();
          }
      },
      error => console.log(error))
    }

  setLabels(){

    this.labels['gl-ledger-Title'] = this.ArrLabels.find((o: any) => o.key === 'gl-ledger-Title').value;

    this.labels['AccountID'] = this.ArrLabels.find( (o:any) => o.key === 'AccountID').value;
    this.labels['valueDate'] = this.ArrLabels.find( (o:any) => o.key === 'valueDate').value;
    this.labels['DR_TUR'] = this.ArrLabels.find( (o:any) => o.key === 'DR_TUR').value;
    this.labels['CR_TUR'] = this.ArrLabels.find( (o:any) => o.key === 'CR_TUR').value;
    this.labels['Balance'] = this.ArrLabels.find( (o:any) => o.key === 'Balance').value;
    this.labels['event_name'] = this.ArrLabels.find((o: any) => o.key === 'event_name').value;
  }

}



// WEBPACK FOOTER //
// ./src/app/components/gls/gl-ledger/gl-ledger.component.ts